import { appSchema } from '@shared/schema/appSchema.js';

const getFilterOperatorOptions = ({ actionFilters, apiFilters, introspectionOperatorOptions, isTransformAction, isTransformApp }) => {
  if (isTransformAction || isTransformApp) {
    return appSchema?.api?.filters?.operators?.map((n) => ({ ...n, label: n.shorthand }));
  }

  if (introspectionOperatorOptions?.length > 0) {
    return introspectionOperatorOptions.map((operator) => ({
      ...operator,
      label: operator.shorthand || operator.label || operator.value,
      shorthand: operator.shorthand || operator.label || operator.value
    }));
  }

  if (!apiFilters?.location || !actionFilters?.isActive) {
    return null;
  }

  const operatorType = actionFilters?.operatorType || 'inherited';

  if (operatorType === 'sql') {
    const sqlOperators = appSchema?.api?.filters?.sqlOperators || [];
    const enabledActionFilterOperators = !actionFilters?.operators ? sqlOperators.map((op) => op.value) : actionFilters.operators.filter((n) => n.isActive === true).map((n) => n.slug);

    return sqlOperators
      .filter((n) => enabledActionFilterOperators.includes(n.value))
      .map((n) => ({
        ...n,
        value: n.value,
        label: n.shorthand,
        shorthand: n.shorthand
      }));
  }

  if (apiFilters?.useCustomOperators && apiFilters?.customOperators) {
    const customOperators = apiFilters.customOperators;
    const enabledActionFilterOperators = !actionFilters?.operators ? Object.keys(customOperators) : actionFilters.operators.filter((n) => n.isActive === true).map((n) => n.slug);

    return Object.entries(customOperators)
      .filter(([key]) => enabledActionFilterOperators.includes(key))
      .map(([key, operator]) => ({
        value: key,
        label: operator.label || key,
        shorthand: operator.label || key
      }));
  }

  const enabledApiFilterOperators = apiFilters?.operators?.filter((n) => n.isActive === true);
  const enabledActionFilterOperators = !actionFilters?.operators ? enabledApiFilterOperators : actionFilters?.operators?.filter((n) => n.isActive === true);

  return appSchema?.api?.filters?.operators?.filter((n) => !!enabledActionFilterOperators?.find((m) => m.slug === n.value)).map((n) => ({ ...n, label: n.shorthand }));
};

export default getFilterOperatorOptions;
